import { useBlogHook } from '@/hooks/useBlogHook'
import Link from 'next/link'
import { useEffect } from 'react'
import BlogCardV1 from './BlogCardV1'
const BlogList = ({ title, subTitle }: { title: string; subTitle: string }) => {
  const { getPosts, posts, setPosts } = useBlogHook()
  useEffect(() => {
    getPosts(
      {
        limit: 4,
        highlight: true,
        currentPage: 1,
      },
      {
        onSuccess: res => {
          setPosts(res.data.data)
        },
      }
    )
  }, [])
  return (
    <>
      {posts && posts.length > 0 ? (
        <section className='blogList mb-5'>
          <div className='head-sec relative mb-3 ml-auto mr-auto text-center'>
            <h3 className={`text-titleSection font-bold leading-normal`}>
              {title}
            </h3>
            <p className='subTitle text-sm uppercase text-dark-600'>
              {subTitle}
            </p>
            <Link
              href='/post'
              className='btnMore absolute right-0 top-[50%] flex h-[36px] translate-y-[-50%] items-center justify-center gap-1 px-2 text-base text-primary-base'
            >
              Xem thêm
            </Link>
          </div>
          <div className={`listBlog grid grid-cols-4 gap-5`}>
            {posts &&
              posts?.map((e, index) => (
                <BlogCardV1 key={index} post={e} idx={index % 2 == 0 ? 0 : 1} />
              ))}
          </div>
        </section>
      ) : (
        ''
      )}
    </>
  )
}
export default BlogList
